// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.InternationalCollaborators_container__aqUs4 {
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/Explore/Pages/InstitutionDetail/Components/InternationalCollaborators/InternationalCollaborators.module.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;AACF","sourcesContent":[".container {\n  width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `InternationalCollaborators_container__aqUs4`
};
export default ___CSS_LOADER_EXPORT___;
